export default __webpack_public_path__ + "static/media/gallery_04.9e3eef34.jpg";